import { Button, ButtonProps, Spinner } from '@chakra-ui/react';
import { forwardRef, ForwardRefRenderFunction } from 'react';

interface CustomButtonProps extends ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  isLoading?: boolean;
}

const CustomButton: ForwardRefRenderFunction<HTMLButtonElement, CustomButtonProps> = (
  { children, variant = 'primary', isLoading = false, ...props },
  ref,
) => {
  const bgColor = variant === 'secondary' ? 'brand.secondary.DEFAULT' : 'brand.primary.DEFAULT';

  return (
    <Button
      ref={ref}
      bg={variant === 'outline' ? 'white' : bgColor}
      color={variant === 'outline' ? 'brand.primary.DEFAULT' : 'white'}
      _hover={{
        bg: variant === 'outline' ? 'brand.primary.DEFAULT' : 'brand.primary.700',
        color: variant === 'outline' ? 'text.white' : 'text.white',
      }}
      _active={{
        bg: variant === 'outline' ? 'transparent' : `${bgColor}.700`,
      }}
      _disabled={{
        bg: 'background.tertiary',
        color: '#344054',
        border: '1px',
        borderColor: 'border.light',
        shadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
      }}
      py={'10px'}
      px={4}
      borderRadius="xl"
      fontFamily={'primary'}
      borderWidth="0px"
      borderColor={variant === 'outline' ? 'border.default' : ''}
      isLoading={isLoading}
      sx={{
        boxShadow:
          '0px 1px 2px 0px #1018280D, 0px -2px 0px 0px #1018280D inset, 0px 0px 0px 1px #1018282E inset',
      }}
      {...props}
    >
      {isLoading ? <Spinner size="sm" /> : children}
    </Button>
  );
};

export default forwardRef(CustomButton);
